import React from 'react';
import {CANVAS_APP_IFRAME_LOADED_STATE_CHANGED} from '@packages/systems/designer/actions';
import {getCanvasAppParentOrigin} from '@packages/utilities/canvas-origin';

export const useNotifyDesignerAppCanvasAppUnload = () => {
  // Add beforeunload event listener to notify Designer app when Canvas is unloaded
  React.useEffect(() => {
    const handleBeforeUnload = () => {
      // Dispatch action to set canvasAppIframeLoaded to false in Designer app
      const message = {
        method: 'dispatch',
        type: CANVAS_APP_IFRAME_LOADED_STATE_CHANGED,
        payload: {isLoaded: false},
      };
      const parentOrigin = getCanvasAppParentOrigin(window);
      if (parentOrigin) {
        window.parent.postMessage(message, parentOrigin);
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
};
